import { createApp } from "vue"
import App from '@/page/vue/2023/guest.vue'
import '@/styles/index.scss'
import tongji from '@/utils/tongji.js'; //引入统计

import Qapm from '@q/qapm';
Qapm('init', {
    appKey: 'isc',
    env: import.meta.env.MODE,
    ratio: 100,
});

tongji(); //统计

const app = createApp(App)
app.mount('#app')